// Mock-Daten für Malergeschäft Labbiento

export const services = [
  {
    id: 1,
    title: "Innenbereich",
    description: "Professionelle Malerarbeiten für Wände, Decken, Treppenhäuser und Renovationen. Wir bringen Farbe in Ihre Räume.",
    image: "https://images.unsplash.com/photo-1693985120993-e9b203ce7631",
    alt: "Professioneller Maler streicht Innenwand mit Rolle"
  },
  {
    id: 2,
    title: "Aussenbereich",
    description: "Fassadenarbeiten, Fenster- und Untersichten-Anstriche. Wetterfester Schutz und ansprechende Optik für Ihr Gebäude.",
    image: "https://images.unsplash.com/photo-1659715417705-9b677377afe1",
    alt: "Schweizer Hausfassade mit frischem Anstrich"
  },
  {
    id: 3,
    title: "Stucco Veneziano",
    description: "Edle Glanztechnik für besondere Wände. Venezianischer Putz verleiht Räumen einen luxuriösen, mediterranen Charakter.",
    image: "https://images.unsplash.com/photo-1534162057773-55bd4a4b5ae1",
    alt: "Stucco Veneziano Glanzwand mit edler Optik"
  },
  {
    id: 4,
    title: "Farbberatung & Gestaltung",
    description: "Individuelle Farbkonzepte für Ihr Zuhause. Wir beraten Sie professionell bei der Auswahl der perfekten Farbtöne.",
    image: "https://images.unsplash.com/photo-1581079949099-ea95c980d186",
    alt: "Professionelle Farbpalette und Farbberatung"
  },
  {
    id: 5,
    title: "Gipser-Ausbesserungen",
    description: "Reparatur von Rissen, Beschädigungen und Unebenheiten. Saubere Ausbesserungsarbeiten für ein perfektes Ergebnis.",
    image: "https://images.unsplash.com/photo-1717281234297-3def5ae3eee1",
    alt: "Gipserarbeiten und Wandreparatur"
  }
];

export const references = [
  {
    id: 1,
    category: "innen",
    image: "https://images.unsplash.com/photo-1581209410127-8211e90da024?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwxfHxmcmVzaGx5JTIwcGFpbnRlZCUyMGxpdmluZyUyMHJvb218ZW58MHx8fHwxNzYzNjcyNTU4fDA&ixlib=rb-4.1.0&q=85",
    alt: "Modern gestrichenes Wohnzimmer mit hellen Wänden"
  },
  {
    id: 2,
    category: "innen",
    image: "https://images.unsplash.com/photo-1657040899606-b22f17a6afd5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwyfHxmcmVzaGx5JTIwcGFpbnRlZCUyMGxpdmluZyUyMHJvb218ZW58MHx8fHwxNzYzNjcyNTU4fDA&ixlib=rb-4.1.0&q=85",
    alt: "Frisch renovierter Wohnraum mit professionellem Anstrich"
  },
  {
    id: 3,
    category: "innen",
    image: "https://images.pexels.com/photos/279607/pexels-photo-279607.jpeg",
    alt: "Heller Wohnbereich nach Renovierung"
  },
  {
    id: 4,
    category: "aussen",
    image: "https://images.unsplash.com/photo-1691166693730-f1d9141551fc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwxfHxob3VzZSUyMGZhY2FkZSUyMGZyZXNoJTIwcGFpbnR8ZW58MHx8fHwxNzYzNjcyNTY0fDA&ixlib=rb-4.1.0&q=85",
    alt: "Renovierte grüne Hausfassade mit frischem Anstrich"
  },
  {
    id: 5,
    category: "aussen",
    image: "https://images.unsplash.com/photo-1720110999984-9482ffaef6a4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwzfHxob3VzZSUyMGZhY2FkZSUyMGZyZXNoJTIwcGFpbnR8ZW58MHx8fHwxNzYzNjcyNTY0fDA&ixlib=rb-4.1.0&q=85",
    alt: "Blaues Einfamilienhaus mit frischer Fassadenfarbe"
  },
  {
    id: 6,
    category: "aussen",
    image: "https://images.pexels.com/photos/106399/pexels-photo-106399.jpeg",
    alt: "Frisch gestrichenes Wohnhaus Aussenansicht"
  },
  {
    id: 7,
    category: "stucco",
    image: "https://images.unsplash.com/photo-1534162057773-55bd4a4b5ae1",
    alt: "Stucco Veneziano Wandgestaltung"
  },
  {
    id: 8,
    category: "stucco",
    image: "https://images.unsplash.com/photo-1534670022376-eb2368089516",
    alt: "Venezianischer Putz mit Glanzeffekt"
  },
  {
    id: 9,
    category: "gipser",
    image: "https://images.unsplash.com/photo-1693985120993-e9b203ce7631",
    alt: "Professionelle Gipserarbeiten und Ausbesserungen"
  },
  {
    id: 10,
    category: "gipser",
    image: "https://images.unsplash.com/photo-1717281234297-3def5ae3eee1",
    alt: "Wandreparatur und Verputzarbeiten"
  }
];

export const usps = [
  {
    id: 1,
    title: "Persönliche Beratung vor Ort",
    description: "Wir kommen zu Ihnen und besprechen Ihr Projekt direkt beim Objekt. Individuelle Lösungen für Ihre Wünsche.",
    icon: "user-check"
  },
  {
    id: 2,
    title: "Saubere, termingerechte Arbeit",
    description: "Pünktlichkeit und Ordnung sind für uns selbstverständlich. Wir halten Termine ein und hinterlassen saubere Baustellen.",
    icon: "clock"
  },
  {
    id: 3,
    title: "Transparente, faire Offerten",
    description: "Keine versteckten Kosten. Sie erhalten detaillierte Kostenvoranschläge und wissen genau, was Sie erwartet.",
    icon: "file-text"
  },
  {
    id: 4,
    title: "Langjährige Erfahrung",
    description: "Jahrelange Expertise in allen Bereichen der Malerei und Spezialtechniken wie Stucco Veneziano.",
    icon: "award"
  }
];

export const processSteps = [
  {
    id: 1,
    title: "Anfrage",
    description: "Sie kontaktieren uns per Telefon, E-Mail oder über unser Kontaktformular."
  },
  {
    id: 2,
    title: "Besichtigung vor Ort",
    description: "Wir vereinbaren einen Termin und besichtigen Ihr Objekt gemeinsam mit Ihnen."
  },
  {
    id: 3,
    title: "Transparente Offerte",
    description: "Sie erhalten eine detaillierte, faire Offerte mit allen Leistungen und Kosten."
  },
  {
    id: 4,
    title: "Ausführung",
    description: "Nach Ihrer Zusage führen wir die Arbeiten sauber, termingerecht und professionell aus."
  },
  {
    id: 5,
    title: "Abnahme",
    description: "Gemeinsame Abnahme der Arbeiten. Ihre Zufriedenheit ist unser Ziel."
  }
];

export const teamMembers = [
  {
    id: 1,
    name: "Michele Labiento",
    role: "Geschäftsführer",
    image: "https://images.pexels.com/photos/5493658/pexels-photo-5493658.jpeg"
  },
  {
    id: 2,
    name: "Unser Team",
    role: "Malermeister & Fachkräfte",
    image: "https://images.pexels.com/photos/6474300/pexels-photo-6474300.jpeg"
  }
];

export const contactInfo = {
  company: "Malergeschäft Labbiento GmbH",
  address: "Kronenplatz 12",
  city: "5600 Lenzburg",
  mobile: "+41 79 520 29 36",
  email: "info@maler-labbiento.ch",
  mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2696.8873!2d8.1772!3d47.3891!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47903b5e5e5e5e5e%3A0x5e5e5e5e5e5e5e5e!2sKronenplatz%2012%2C%205600%20Lenzburg!5e0!3m2!1sde!2sch!4v1234567890"
};